// App
import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUser } from './context/UserContext';
import {Header} from './components/shared/Header';
import {AuthPage} from './components/shared/AuthPage';

// Dashboards
import {AdminDashboard} from './dashboards/AdminDashboard';
import {ClientDashboard} from './dashboards/ClientDashboard';
import {DirectivoDashboard} from './dashboards/DirectivoDashboard';
import {FinanzasDashboard} from './dashboards/FinanzasDashboard';
import {HRDashboard} from './dashboards/HRDashboard';
import {SupervisorDashboard} from './dashboards/SupervisorDashboard';
import {TecnicoDashboard} from './dashboards/TecnicoDashboard';
import {AntecedentesDashboard} from './dashboards/AntecedentesDashboard';
import {EcotechDashboard} from './dashboards/EcotechDashboard';
import {PracticanteDashboard} from './dashboards/PracticanteDashboard';

const App = () => {
  const { user, userData, loading } = useUser();
  const [selectedRole, setSelectedRole] = useState(null);
  const [isTechnicianWorking, setIsTechnicianWorking] = useState(false); 
  const [selectedClientProfile, setSelectedClientProfile] = useState(null);

  useEffect(() => {
    const tieneRolAsignado = userData?.rol || (userData?.roles && userData.roles.length > 0);

    if (user && userData && tieneRolAsignado) {
        
        const defaultRole = userData.rol || userData.roles[0] || 'invitado';

        setSelectedRole(prevRole => {
            if (prevRole) return prevRole;

            return defaultRole;
        });
        
    } else if (!user) {
        setSelectedRole(null);
        setSelectedClientProfile(null);
    }
  }, [user, userData]);

  const renderDashboard = () => {
    switch (selectedRole) {
      case 'administrador':
        return <AdminDashboard />;
        
      case 'directivo':
        return <DirectivoDashboard />;
        
      case 'finanzas':
        return <FinanzasDashboard />;

      case 'practicante':
        return <PracticanteDashboard />;  
        
      case 'rh':
        return <HRDashboard />;
        
      case 'supervisor':
        return <SupervisorDashboard />;
        
      case 'antecedentes': 
        return <AntecedentesDashboard />;

      case 'ecotech':
        return <EcotechDashboard />;

      case 'tecnico':
        return (
          <TecnicoDashboard 
            setIsWorkingState={setIsTechnicianWorking} 
          />
        );
        
      case 'cliente':
        return (
          <ClientDashboard 
            selectedClientProfile={selectedClientProfile} 
          />
        );
      
      default:
        return (
          <div className="flex flex-col items-center justify-center h-64 text-gray-500">
            <h2 className="text-2xl font-bold mb-2">Rol Desconocido</h2>
            <p>Tu usuario no tiene un rol asignado correctamente.</p>
            <p className="text-sm mt-2">Rol detectado: {selectedRole || 'Ninguno'}</p>
          </div>
        );
    }
  };

  // Pantalla de Carga Global
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#cdcdcd] text-gray-700">
        <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-4 border-gray-600 border-t-transparent mb-2"></div>
            <p className="font-semibold">Cargando Sistema Evelsa...</p>
        </div>
      </div>
    );
  }

  // Renderizado Principal
  return (
    <div className="bg-[#cdcdcd] min-h-screen font-sans">
      <ToastContainer
        position="bottom-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Header
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
        isWorking={isTechnicianWorking}
        selectedClientProfile={selectedClientProfile}
        setSelectedClientProfile={setSelectedClientProfile} 
      />
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {user && userData ? (
            renderDashboard()
        ) : (
            <AuthPage />
        )}
      </main>
    </div>
  );
}

export default App;